import FilterByPayment from './FilterByPayment';

export default FilterByPayment;
